import { createFileRoute } from '@tanstack/react-router'
import SolutionDetailPage from '@/spa/pages/solutions/SolutionDetailPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/solutions/$defectType')({
  component: SolutionDetailPage,
  errorComponent: routeErrorComponent,
})
